import { Configuration } from "@freightsimple/generated-dashboard-openapi-client/runtime";
import { WebhooksApi } from "@freightsimple/generated-dashboard-openapi-client/apis/WebhooksApi";
import { useAuthentication } from "@/Slices/authenticationSlice";
import { getConfig } from "@/Apis/getConfig";

export function useWebhooksApi(): WebhooksApi {
  const { accessToken } = useAuthentication();

  return new WebhooksApi(
    new Configuration({ ...getConfig(), accessToken: accessToken }),
  );
}
